import { Dispatch, SetStateAction } from 'react'

import { User } from 'firebase/auth'
import {
  collection,
  doc,
  DocumentReference,
  getDoc,
  getDocs,
  onSnapshot,
  query,
  setDoc,
  updateDoc,
  where,
} from 'firebase/firestore'

import { RegFormType } from '../../types'
import { firestore } from '../firebaseConfig'

export const createNewUserDocument = async (
  collection: string,
  userData: RegFormType,
  credentials: User,
) => {
  const userDocRef = doc(firestore, collection, credentials.uid)
  const userDoc = await getDoc(userDocRef)

  if (!userDoc.exists()) {
    await setDoc(userDocRef, {
      ...userData,
      image: credentials.photoURL ? credentials.photoURL : '',
      professors: collection === 'students' ? [] : undefined,
    })
  }
}

export const updateDocument = async <T extends object>(
  documentRef: DocumentReference,
  newData: T,
) => {
  try {
    await updateDoc(documentRef, newData) // Aquí newData debe ser un objeto

    return 'Documento actualizado correctamente'
  } catch (error) {
    console.error('Error al actualizar el documento:', error)
    return error
  }
}

export const getAllDocuments = async (collectionName: string) => {
  const querySnapshot = await getDocs(collection(firestore, collectionName))
  const documents = querySnapshot.docs.map((doc) => doc.data())
  return documents
}

export const getFilterDocuments = async (
  collectionName: string,
  param: string,
  value: string,
) => {
  const collectionRef = await collection(firestore, collectionName)

  const q = query(collectionRef, where(param, '==', value))

  try {
    const querySnapshot = await getDocs(q)

    const documents = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }))

    return documents
  } catch (error) {
    console.error('Error retrieving documents:', error)
  }
}

export const subscribeToDocumentChanges = <T,>(
  collectionName: string,
  documentId: string,
  setData: (data: T) => void,
  setError?: Dispatch<SetStateAction<string | null>>,
) => {
  const docRef = doc(firestore, collectionName, documentId)

  // Configura el listener con onSnapshot
  const unsubscribe = onSnapshot(
    docRef,
    (docSnapshot) => {
      if (docSnapshot.exists()) {
        const data = docSnapshot.data()
        collectionName === 'lists'
          ? setData(data.items || [])
          : setData(data as T)
      } else {
        setError && setError('El documento no existe')
      }
    },
    (error) => {
      setError && setError(`Error al escuchar cambios: ${error}`)
    },
  )

  return unsubscribe
}
